var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconArrowRightRound = function SvgIconArrowRightRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 45a20 20 0 0 0 14.14-34.14 20 20 0 1 0-28.28 28.28A19.87 19.87 0 0 0 25 45m0 5a25 25 0 1 1 25-25 25 25 0 0 1-25 25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m36.57 22 4.6 2.92-4.6 2.92v-.02l-18.99 12.1-2.41-4.16L32.2 24.92 15.17 14.07l2.41-4.15Z"
  })));
};
export default SvgIconArrowRightRound;